var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo1TextLayout2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 216,
    height: 434,
    viewBox: "0 0 216 434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18669",
    "data-name": "Rectangle 18669",
    width: 216,
    height: 434,
    transform: "translate(-865 -1110)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_63",
    "data-name": "Mask Group 63",
    transform: "translate(865 1110)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98899",
    "data-name": "Group 98899",
    transform: "translate(-1071 -1283.68)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Shirt_Large_Blue",
    "data-name": "Shirt / Large / Blue",
    transform: "translate(212 536.015)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "AvenirLTStd-Heavy, Avenir LT Std",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Shirt / Large / Blue")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18381",
    "data-name": "Rectangle 18381",
    width: 216.193,
    height: 17.169,
    transform: "translate(206 200.225)",
    fill: "rgba(0,0,0,0.5)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "AS_Store",
    "data-name": "AS Store",
    transform: "translate(226.753 181.618)",
    fill: "#fff",
    fontSize: 7,
    fontFamily: "AvenirLTStd-Heavy, Avenir LT Std",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "AS Store")), /*#__PURE__*/React.createElement("text", {
    id: "Home_goods_store",
    "data-name": "Home goods store",
    transform: "translate(226.753 192.348)",
    fill: "#fff",
    fontSize: 7,
    fontFamily: "AvenirLTStd-Roman, Avenir LT Std"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Home goods store")), /*#__PURE__*/React.createElement("g", {
    id: "Group_72744",
    "data-name": "Group 72744",
    transform: "translate(212 471.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_215376",
    "data-name": "Path 215376",
    transform: "translate(0)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.356,0H174.975a5.356,5.356,0,0,1,5.356,5.356V25a5.356,5.356,0,0,1-5.356,5.356H5.356A5.356,5.356,0,0,1,0,25V5.356A5.356,5.356,0,0,1,5.356,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.35638427734375 0.9999961853027344 C 2.954269409179688 0.9999961853027344 1 2.954269409179688 1 5.356382369995117 L 1 24.99642944335938 C 1 27.3985424041748 2.954269409179688 29.35281562805176 5.35638427734375 29.35281562805176 L 174.9750213623047 29.35281562805176 C 177.3771362304688 29.35281562805176 179.3314056396484 27.3985424041748 179.3314056396484 24.99642944335938 L 179.3314056396484 5.356382369995117 C 179.3314056396484 2.954269409179688 177.3771362304688 0.9999961853027344 174.9750213623047 0.9999961853027344 L 5.35638427734375 0.9999961853027344 M 5.35638427734375 -3.814697265625e-06 L 174.9750213623047 -3.814697265625e-06 C 177.9332427978516 -3.814697265625e-06 180.3314056396484 2.39813232421875 180.3314056396484 5.356382369995117 L 180.3314056396484 24.99642944335938 C 180.3314056396484 27.95467758178711 177.9332427978516 30.35281562805176 174.9750213623047 30.35281562805176 L 5.35638427734375 30.35281562805176 C 2.39813232421875 30.35281562805176 0 27.95467758178711 0 24.99642944335938 L 0 5.356382369995117 C 0 2.39813232421875 2.39813232421875 -3.814697265625e-06 5.35638427734375 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Comment",
    transform: "translate(10.036 16.942)",
    fill: "#fff",
    fontSize: 7,
    fontFamily: "AvenirLTStd-Roman, Avenir LT Std",
    opacity: 0.849
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Comment")), /*#__PURE__*/React.createElement("g", {
    id: "Group_97458",
    "data-name": "Group 97458",
    transform: "translate(154.897 3.358)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9790",
    "data-name": "Rectangle 9790",
    width: 21.461,
    height: 22.534,
    rx: 6,
    transform: "translate(0 0)",
    fill: "#f17721"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(5.794 6.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78700",
    "data-name": "Path 78700",
    d: "M1.274,2.255a.809.809,0,0,1,1.147-.92l7.812,3.906a.809.809,0,0,1,0,1.447L2.421,10.6a.809.809,0,0,1-1.147-.92L2.092,6.4l4.75-.439-4.75-.439L1.274,2.255Z",
    transform: "translate(-1.25 -1.25)",
    fill: "#fff",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72733",
    "data-name": "Group 72733",
    transform: "translate(211.803 582.229)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_556",
    "data-name": "Rectangle 556",
    width: 95.501,
    height: 24.68,
    rx: 12.34,
    transform: "translate(0.197 -0.229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Custom_Bid",
    "data-name": "Custom Bid",
    transform: "translate(18.197 15.771)",
    fill: "#1a1a1a",
    fontSize: 11,
    fontFamily: "AvenirLTStd-Heavy, Avenir LT Std",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Custom Bid"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_97459",
    "data-name": "Group 97459",
    transform: "translate(316.889 583.302)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_556-2",
    "data-name": "Rectangle 556",
    width: 94.428,
    height: 24.68,
    rx: 12,
    transform: "translate(0.111 -0.302)",
    fill: "#f17721"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Bid_1280",
    "data-name": "Bid 1280",
    transform: "translate(24.111 15.698)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "AvenirLTStd-Heavy, Avenir LT Std",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Bid 1280"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_97716",
    "data-name": "Group 97716",
    transform: "translate(214.657 205.59)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "to_add_money_in_your_wallet_to_bid_the_auction",
    "data-name": "to add money in your wallet to bid the auction",
    transform: "translate(37.557 5)",
    fill: "#fff",
    fontSize: 7,
    fontFamily: "AvenirLTStd-Medium, Avenir LT Std",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "to add money in your wallet to bid the live")), /*#__PURE__*/React.createElement("text", {
    id: "Click_here",
    "data-name": "Click here",
    transform: "translate(0 5)",
    fill: "#fff",
    fontSize: 7,
    fontFamily: "AvenirLTStd-Heavy, Avenir LT Std",
    fontWeight: 800,
    textDecoration: "underline"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Click here"))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(212.903 181.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9429",
    d: "M6.622,291.965A.581.581,0,0,1,7,292.994L3.45,296.039,7,299.083a.581.581,0,1,1-.755.879L2.18,296.48a.581.581,0,0,1,0-.884l4.07-3.485a.581.581,0,0,1,.372-.147Z",
    transform: "translate(-1.976 -291.965)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_97895",
    "data-name": "Group 97895",
    transform: "translate(212 508.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97893",
    "data-name": "Group 97893",
    transform: "translate(55.727 0)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_1250",
    "data-name": 1250,
    transform: "translate(42.509 10.649)",
    fill: "#fdfdfd",
    fontSize: 8,
    fontFamily: "AvenirLTStd-Heavy, Avenir LT Std",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1250")), /*#__PURE__*/React.createElement("g", {
    id: "coin",
    transform: "translate(64.946 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97844",
    "data-name": "Group 97844",
    transform: "translate(4.697 7.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215343",
    "data-name": "Path 215343",
    d: "M132.188,258.382c0-1.331,3.029-2.411,6.766-2.411s6.765,1.08,6.765,2.411V260.6c0,1.331-3.029,2.411-6.765,2.411s-6.766-1.08-6.766-2.411Z",
    transform: "translate(-132.188 -255.971)",
    fill: "#fe9923",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_97845",
    "data-name": "Group 97845",
    transform: "translate(4.697 7.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215344",
    "data-name": "Path 215344",
    d: "M138.955,255.971c3.736,0,6.765,1.08,6.765,2.411s-3.029,2.411-6.765,2.411-6.766-1.079-6.766-2.411S135.218,255.971,138.955,255.971Z",
    transform: "translate(-132.189 -255.971)",
    fill: "#fecd3d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_97846",
    "data-name": "Group 97846",
    transform: "translate(6.08 8.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215345",
    "data-name": "Path 215345",
    d: "M176.343,287.558c2.973,0,5.382.576,5.382,1.284s-2.409,1.284-5.382,1.284-5.383-.575-5.383-1.284S173.37,287.558,176.343,287.558Z",
    transform: "translate(-170.96 -287.558)",
    fill: "#fea832",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_215346",
    "data-name": "Path 215346",
    d: "M169.328,399.408h.578v1.123c-.2-.032-.39-.069-.578-.108Zm8.36-.595v1.18q.313-.12.579-.252v-.929Zm-6.271,1.895c.191.014.384.025.579.032v-1.073h-.579Zm-4.18-.967q.266.132.579.252v-1.181h-.579Zm6.271,1c.2-.007.388-.019.578-.032v-1.04h-.578Zm2.091-.209c.2-.032.391-.069.578-.108v-1.015H175.6Z",
    transform: "translate(-161.289 -386.681)",
    fill: "#c85929"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_97847",
    "data-name": "Group 97847",
    transform: "translate(0.756 12.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215347",
    "data-name": "Path 215347",
    d: "M22.921,398.667v.718h.717v.512h-.717v.718h-.513V399.9H21.69v-.512h.718v-.718Z",
    transform: "translate(-21.69 -398.667)",
    fill: "#fea832"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_97848",
    "data-name": "Group 97848",
    transform: "translate(13.873 4.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215348",
    "data-name": "Path 215348",
    d: "M390.655,178.224v.718h.718v.512h-.718v.718h-.513v-.718h-.717v-.512h.717v-.718Z",
    transform: "translate(-389.426 -178.224)",
    fill: "#fea832"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_97849",
    "data-name": "Group 97849",
    transform: "translate(1.1 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215349",
    "data-name": "Path 215349",
    d: "M32.577,58.709v.718h.717v.511h-.717v.718h-.513v-.718h-.718v-.511h.718v-.718Z",
    transform: "translate(-31.347 -58.709)",
    fill: "#fea832"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_97850",
    "data-name": "Group 97850",
    transform: "translate(0 0.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215350",
    "data-name": "Path 215350",
    d: "M.624,89.5c-.666-1.154,1.417-3.6,4.653-5.471s6.4-2.448,7.065-1.295L13.45,84.65c.666,1.154-1.417,3.6-4.653,5.471s-6.4,2.449-7.065,1.295L.624,89.5Z",
    transform: "translate(-0.5 -82.139)",
    fill: "#fe9923",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_97851",
    "data-name": "Group 97851",
    transform: "translate(0 0.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215351",
    "data-name": "Path 215351",
    d: "M5.277,84.026c3.236-1.869,6.4-2.448,7.065-1.295s-1.417,3.6-4.653,5.471S1.29,90.65.624,89.5s1.417-3.6,4.653-5.471Z",
    transform: "translate(-0.5 -82.139)",
    fill: "#fecd3d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_97852",
    "data-name": "Group 97852",
    transform: "translate(1.278 1.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215352",
    "data-name": "Path 215352",
    d: "M40.383,113.749c2.574-1.486,4.949-2.192,5.3-1.578s-1.445,2.317-4.019,3.8-4.948,2.192-5.3,1.578S37.809,115.236,40.383,113.749Z",
    transform: "translate(-36.321 -111.949)",
    fill: "#fea832",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_215353",
    "data-name": "Path 215353",
    d: "M76.529,185.328l.536.929q-.26.137-.518.261l-.52-.9Zm-4.549,1.639.464.8a6.254,6.254,0,0,0,.627-.071l-.589-1.022Zm2.107-.53.508.88q.272-.089.554-.2l-.561-.973Zm3.751-1.865.536.929q.247-.156.485-.316l-.52-.9Zm3.694-3.12-.5.29.59,1.021c.14-.172.266-.342.375-.507Zm-2.013,1.85.561.973q.233-.19.446-.382l-.507-.879Z",
    transform: "translate(-69.43 -177.074)",
    fill: "#c85929"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Riya_Rai",
    "data-name": "Riya Rai",
    transform: "translate(0 10.649)",
    fill: "#fdfdfd",
    fontSize: 8,
    fontFamily: "AvenirLTStd-Heavy, Avenir LT Std",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Riya Rai"))), /*#__PURE__*/React.createElement("text", {
    id: "Top_Biddings_:",
    "data-name": "Top Biddings :",
    transform: "translate(0 10.481)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "AvenirLTStd-Heavy, Avenir LT Std",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Top Biddings :"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_97697",
    "data-name": "Group 97697",
    transform: "translate(403.806 478.144)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_841",
    "data-name": "Ellipse 841",
    cx: 2.683,
    cy: 2.683,
    r: 2.683,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_842",
    "data-name": "Ellipse 842",
    cx: 2.683,
    cy: 2.683,
    r: 2.683,
    transform: "translate(0 12.877)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_843",
    "data-name": "Ellipse 843",
    cx: 2.146,
    cy: 2.146,
    r: 2.146,
    transform: "translate(0 6.438)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_97715",
    "data-name": "Group 97715",
    transform: "translate(368.395 173.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18380",
    "data-name": "Rectangle 18380",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e8e8e8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.995,
    height: 23.607,
    rx: 11.804,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 42.995,
    height: 22.607,
    rx: 11.304,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_97714",
    "data-name": "Group 97714",
    transform: "translate(6.438 7.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97712",
    "data-name": "Group 97712",
    transform: "translate(19.281 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97711",
    "data-name": "Group 97711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "multiple-users-silhouette"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215324",
    "data-name": "Path 215324",
    d: "M6.963,8.015a2.1,2.1,0,0,1,.976,1.558,1.692,1.692,0,1,0-.976-1.558ZM5.854,11.479A1.692,1.692,0,1,0,4.162,9.787,1.692,1.692,0,0,0,5.854,11.479Zm.718.115H5.136a2.169,2.169,0,0,0-2.167,2.167v1.756l0,.028.121.038a9.863,9.863,0,0,0,2.946.475,6.048,6.048,0,0,0,2.572-.483l.113-.057h.012V13.762A2.169,2.169,0,0,0,6.572,11.595Zm2.8-1.747H7.947A2.085,2.085,0,0,1,7.3,11.3a2.575,2.575,0,0,1,1.839,2.464v.541a5.831,5.831,0,0,0,2.271-.477l.113-.057h.012V12.014A2.169,2.169,0,0,0,9.372,9.848ZM2.885,9.733a1.681,1.681,0,0,0,.9-.261,2.094,2.094,0,0,1,.787-1.336c0-.032,0-.063,0-.1A1.692,1.692,0,1,0,2.885,9.733ZM4.4,11.3a2.087,2.087,0,0,1-.643-1.445c-.053,0-.105-.008-.159-.008H2.167A2.169,2.169,0,0,0,0,12.014v1.756L0,13.8l.121.038a10.159,10.159,0,0,0,2.44.459v-.53A2.575,2.575,0,0,1,4.4,11.3Z",
    transform: "translate(0 -6.348)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_97713",
    "data-name": "Group 97713",
    transform: "translate(0 0.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72747",
    "data-name": "Group 72747",
    transform: "translate(5.365 0)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_18",
    "data-name": 18,
    transform: "translate(0 5)",
    fill: "#fff",
    fontSize: 7,
    fontFamily: "AvenirLTStd-Heavy, Avenir LT Std",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "18"))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_850",
    "data-name": "Ellipse 850",
    cx: 2.683,
    cy: 3.219,
    rx: 2.683,
    ry: 3.219,
    transform: "translate(0 1.073)",
    fill: "#04cc0c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_97911",
    "data-name": "Group 97911",
    transform: "translate(212 425.565)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18404",
    "data-name": "Rectangle 18404",
    width: 196.367,
    height: 40.776,
    rx: 9,
    transform: "translate(0 0)",
    fill: "#121212",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_97910",
    "data-name": "Group 97910",
    transform: "translate(7.511 5.365)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "I_have_followed_your_Store_I_am_looking_forward_to_your_content.",
    "data-name": "I have followed your Store, I am looking forward to your  content.",
    transform: "translate(0 16.803)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "AvenirLTStd-Roman, Avenir LT Std"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I have followed your Store, I am looking forward to your "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 8
  }, "content.")), /*#__PURE__*/React.createElement("text", {
    id: "Shubham_Verma",
    "data-name": "Shubham Verma",
    transform: "translate(0 5)",
    fill: "#fff",
    fontSize: 7,
    fontFamily: "AvenirLTStd-Heavy, Avenir LT Std",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Shubham Verma")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_97912",
    "data-name": "Group 97912",
    transform: "translate(212 391.227)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18404-2",
    "data-name": "Rectangle 18404",
    width: 196.367,
    height: 31.118,
    rx: 9,
    transform: "translate(0 0)",
    fill: "#121212",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_97910-2",
    "data-name": "Group 97910",
    transform: "translate(7.511 6.438)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Wonderful_livestream_I_gave_you_20_likes_",
    "data-name": "Wonderful livestream, I gave you 20 likes!",
    transform: "translate(0 15.73)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "AvenirLTStd-Roman, Avenir LT Std"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Wonderful livestream, I gave you 20 likes!")), /*#__PURE__*/React.createElement("text", {
    id: "Seema_Deep",
    "data-name": "Seema Deep",
    transform: "translate(0 5)",
    fill: "#fff",
    fontSize: 7,
    fontFamily: "AvenirLTStd-Heavy, Avenir LT Std",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Seema Deep")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_97914",
    "data-name": "Group 97914",
    transform: "translate(212 365.474)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18404-3",
    "data-name": "Rectangle 18404",
    width: 196.367,
    height: 22.534,
    rx: 9,
    transform: "translate(0 0)",
    fill: "#f07721"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Abhishek_welcome_to_the_livestream.",
    "data-name": "Abhishek,welcome to the livestream.",
    transform: "translate(30 13.526)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "AvenirLTStd-Heavy, Avenir LT Std",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Abhishek,welcome to the livestream.")), /*#__PURE__*/React.createElement("g", {
    id: "Group_97913",
    "data-name": "Group 97913",
    transform: "translate(10.164 3.146)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "messenger",
    width: 15.589,
    height: 15.589,
    transform: "translate(0 0)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Hi",
    transform: "translate(3.897 9.872)",
    fill: "#fff",
    fontSize: 7,
    fontFamily: "AvenirLTStd-Black, Avenir LT Std",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Hi")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_98051",
    "data-name": "Group 98051",
    transform: "translate(203 552.476)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18416",
    "data-name": "Rectangle 18416",
    width: 50.076,
    height: 24.874,
    rx: 12.437,
    transform: "translate(9 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_97842",
    "data-name": "Group 97842",
    transform: "translate(13.444 6.176)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_00:30",
    "data-name": "00:30",
    transform: "translate(14.371 7.348)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "AvenirLTStd-Black, Avenir LT Std",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "00:30")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215377",
    "data-name": "Path 215377",
    d: "M6.107,1a5.107,5.107,0,1,0,5.107,5.107A5.107,5.107,0,0,0,6.107,1ZM7.828,7.828a.464.464,0,0,1-.656,0L5.779,6.435a.464.464,0,0,1-.136-.328V3.321a.464.464,0,1,1,.929,0V5.915L7.828,7.171a.464.464,0,0,1,0,.656Z",
    transform: "translate(-1 -1)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_98876",
    "data-name": "Group 98876",
    transform: "translate(5 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18573",
    "data-name": "Rectangle 18573",
    width: 59.017,
    height: 18.242,
    rx: 5,
    transform: "translate(207.438 217.394)",
    fill: "rgba(0,0,0,0.55)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_98581",
    "data-name": "Group 98581",
    transform: "translate(215.879 219.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98559",
    "data-name": "Group 98559",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98558",
    "data-name": "Group 98558"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215592",
    "data-name": "Path 215592",
    d: "M11.425,10.029H9.475a2.229,2.229,0,0,1,0-4.457h1.95a.278.278,0,0,0,.279-.279V4.458a1.112,1.112,0,0,0-1.026-1.105L9.078.558A1.1,1.1,0,0,0,7.565.15L2.081,3.343H1.117A1.115,1.115,0,0,0,0,4.458v6.686a1.115,1.115,0,0,0,1.114,1.114h9.472A1.115,1.115,0,0,0,11.7,11.143v-.836A.278.278,0,0,0,11.425,10.029Zm-2-7.746.607,1.06H7.6ZM3.188,3.343,7.846.632A.539.539,0,0,1,8.259.576a.546.546,0,0,1,.335.259h0L4.288,3.343Z",
    transform: "translate(-0.003 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215593",
    "data-name": "Path 215593",
    d: "M302.292,234.674h-1.95a1.671,1.671,0,0,0,0,3.343h1.95a.837.837,0,0,0,.836-.836V235.51A.837.837,0,0,0,302.292,234.674Zm-1.95,2.229a.557.557,0,1,1,.557-.557A.558.558,0,0,1,300.341,236.9Z",
    transform: "translate(-290.87 -228.545)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_98560",
    "data-name": "Group 98560",
    transform: "translate(2.136 4.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0.318 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M444.666,518.985l-.024.073a.286.286,0,0,1,.194.367c-.061.218-.343,1.069-.478,1.473l-.063.188c0,.011-.386,1.2-.588,1.809a3.974,3.974,0,0,1-.154.4.155.155,0,0,1-.123.089l.585.072.733-1.955h.5s1.4.045,1.7-.836a1.14,1.14,0,0,0-.013-.66.683.683,0,0,1-.3.683,1.447,1.447,0,0,1-.8.287h-.956l.654-2Z",
    transform: "translate(-443.431 -518.288)",
    fill: "#00057d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M11.024,452.142v.039H10v-.039a.158.158,0,0,1,.158-.158h.709A.158.158,0,0,1,11.024,452.142Z",
    transform: "translate(-8.165 -449.783)",
    fill: "#f17721"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M30.767,401.987a.1.1,0,0,1,0,.2H30.1a.1.1,0,0,1,0-.2Z",
    transform: "translate(-28.085 -400.026)",
    fill: "#f17721"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M701.611,423.841a1.023,1.023,0,0,1,.586.017.546.546,0,0,0-.586-.017l-.343.98a.951.951,0,0,1,.622.094s-.615-.213-.781.1a.208.208,0,0,0,.087.218s-.118-.141.17-.2a.983.983,0,0,1,.363.036s-.543-.049-.513.118.548.182.759.117.034-.29.034-.29l.26-1.064s.165-.027.071-.223a.574.574,0,0,0-.673-.185C701.508,423.657,701.551,423.755,701.611,423.841Z",
    transform: "translate(-699.224 -423.497)",
    fill: "#f07721"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M0,2.47s.793-.225.939-.884c0,0,.261-.88-.822-1.081L.262,0A1.282,1.282,0,0,1,1.287.8a1.353,1.353,0,0,1-.163,1.062A1.742,1.742,0,0,1,0,2.47Z",
    transform: "translate(2.71 0.726)",
    fill: "#f07721"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29-2",
    "data-name": "Path 29",
    d: "M483.014,519.315a.363.363,0,0,1-.015.11c-.081.289-.541,1.433-.541,1.433s-.24.52-.539.556l-.045.093h1.541s1.4.045,1.7-.836a1.14,1.14,0,0,0-.013-.66.683.683,0,0,1-.3.683,1.446,1.446,0,0,1-.8.287h-.956l.653-2h-.615S483.06,519.131,483.014,519.315Z",
    transform: "translate(-481.874 -516.237)",
    fill: "#00057d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M1.989,1.625A.842.842,0,0,0,1.267.571v0A4.247,4.247,0,0,0,.263.6S-.417.1.41.022A2.544,2.544,0,0,1,1.516.087a1.186,1.186,0,0,1,.82.756A1.353,1.353,0,0,1,2.174,1.9a1.742,1.742,0,0,1-1.124.6S1.844,2.284,1.989,1.625Z",
    transform: "translate(1.364 2.731)",
    fill: "#00057d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_98562",
    "data-name": "Group 98562",
    transform: "translate(232.118 223.832)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_78.99",
    "data-name": "\\u20B978.99",
    transform: "translate(0 5)",
    fill: "#fff",
    fontSize: 7,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20B9"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "AvenirLTStd-Heavy, Avenir LT Std",
    fontWeight: 800
  }, "78.99")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_97894",
    "data-name": "Group 97894",
    transform: "translate(212 543.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97747",
    "data-name": "Group 97747"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_1000",
    "data-name": "\\u20B91000",
    transform: "translate(0 7)",
    fill: "#f07721",
    fontSize: 9,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20B9"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "AvenirLTStd-Heavy, Avenir LT Std",
    fontWeight: 800
  }, "1000")), /*#__PURE__*/React.createElement("text", {
    id: "_3000",
    "data-name": "\\u20B93000",
    transform: "translate(31.269 7.4)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "Helvetica",
    opacity: 0.569,
    textDecoration: "line-through"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20B9"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "AvenirLTStd-Roman, Avenir LT Std"
  }, "3000"))), /*#__PURE__*/React.createElement("text", {
    id: "_5_Estimated_Shipping_Cost_Taxes_",
    "data-name": "(5% Estimated Shipping Cost + Taxes)",
    transform: "translate(61.789 7)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "AvenirLTStd-Roman, Avenir LT Std",
    opacity: 0.573
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(5% Estimated Shipping Cost + Taxes)")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo1TextLayout2);
export default __webpack_public_path__ + "static/media/video1-text-layout2.f59b83a1d2e2869d060125c71740bd13.svg";
export { ForwardRef as ReactComponent };